import React from 'react';
import { PropTypes } from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import CustomIcon from '../../CustomIcon';

export const AVATAR_SELECTOR_REVEAL = 'avatarSelectorReveal';

export default class MosaicItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getImageSelectedClass = this.getImageSelectedClass.bind(this);
    this.imageSelectorLayer = this.imageSelectorLayer.bind(this);
    this.handleSelectorLayerClick = this.handleSelectorLayerClick.bind(this);
  }

  static propTypes = {
    selectedImage: PropTypes.string,
    imageUrl: PropTypes.string,
    imageId: PropTypes.string,
    selectImage: PropTypes.func,
    itemClass: PropTypes.string,
    allowImageSelectorLayer: PropTypes.any,
    imageSelectorLayer: PropTypes.func
  };

  handleSelectorLayerClick(event) {
    const { imageSelectorLayer } = this.props;

    event.preventDefault();
    event.stopPropagation();
    imageSelectorLayer();
  }

  imageSelectorLayer() {
    const { allowImageSelectorLayer, itemClass } = this.props;

    if (allowImageSelectorLayer) {
      return (
        <div className={`editable ${itemClass}`} onClick={this.handleSelectorLayerClick}>
          <CustomIcon name="photo-camera" size={30} />
          <span>{I18n.t('userProfile.openAvatarSelector')}</span>
        </div>
      );
    }
  }

  getImageSelectedClass = (selectedImage = '', index = -1, imageUrl) => {
    const isSelectedImage = selectedImage === index || selectedImage === imageUrl;
    return isSelectedImage ? 'selected' : '';
  };

  manageClick = event => {
    const { selectImage, imageId } = this.props;
    if (selectImage) {
      selectImage(event, imageId);
    }
  };

  render() {
    const { selectedImage, imageUrl, imageId, itemClass, allowImageSelectorLayer } = this.props;

    const selectedImageClass = this.getImageSelectedClass(selectedImage, imageId, imageUrl);

    return (
      <div
        onClick={this.manageClick}
        className={`${itemClass} ${selectedImageClass} ${
          allowImageSelectorLayer ? 'image-grid-item' : 'image-grid-item-disabled'
        }`}
      >
        {this.imageSelectorLayer()}
        <img src={imageUrl} alt="presentation" className={`${itemClass} classroom-image`} />
      </div>
    );
  }
}
